import { render, staticRenderFns } from "./domain-not-found-overlay.vue?vue&type=template&id=d2a71c60"
import script from "./domain-not-found-overlay.vue?vue&type=script&lang=js"
export * from "./domain-not-found-overlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2a71c60')) {
      api.createRecord('d2a71c60', component.options)
    } else {
      api.reload('d2a71c60', component.options)
    }
    module.hot.accept("./domain-not-found-overlay.vue?vue&type=template&id=d2a71c60", function () {
      api.rerender('d2a71c60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/main/components/site-overlay/domain-not-found-overlay.vue"
export default component.exports